module.exports = __webpack_public_path__ + "static/media/marker.1de19570.svg";